module.exports = __webpack_public_path__ + "img/municipio-mais-simples.44353a0e.jpg";